export default "__VITE_ASSET__Bad6UV16__"